// src/components/StatusBadge/StatusBadge.jsx
//
// Reusable, color-coded badge for statuses, priorities, and roles.
// Usage:
//   <StatusBadge label="In Progress" tone="info" />
//   <StatusBadge label={priority} tone={priorityTone(priority)} dot />

import React from "react";
import "./StatusBadge.scss";

// Best-effort auto tone detection for common status/priority strings so
// existing call sites can pass a raw value without mapping it themselves.
const TONE_MAP = {
  done: "success",
  completed: "success",
  approved: "success",
  active: "success",
  "in progress": "info",
  inprogress: "info",
  in_progress: "info",
  pending: "warning",
  "on hold": "warning",
  blocked: "danger",
  overdue: "danger",
  cancelled: "neutral",
  canceled: "neutral",
  high: "danger",
  urgent: "danger",
  medium: "warning",
  low: "success",
};

function inferTone(label) {
  const key = String(label || "").trim().toLowerCase();
  return TONE_MAP[key] || "neutral";
}

export default function StatusBadge({ label, tone, dot = false, size = "md" }) {
  const resolvedTone = tone || inferTone(label);
  return (
    <span
      className={`status-badge status-badge--${resolvedTone} status-badge--${size}`}
    >
      {dot && <span className="status-badge__dot" aria-hidden="true" />}
      {label ?? "—"}
    </span>
  );
}
